/*global define:true */

// CAREFUL WITH THIS GUY!  WE NEED TO GET IT UP TO PARITY WITH MIN/CORE.JS AND THEN KEEP IT THAT WAY!!! TODO -- RS
// Moved all the good parts into modules. What's scary? Legacy code in legacy code. Yikes. -- MS

mmf_modules.define('legacy_core',[
    'jquery',
    'utils/ensure_dataLayer',
    'utils/ads',
    'utils/urls',
    'utils/user',
    'utils/ux'
], function (
    $,
    dataLayer,
    Ads,
    Urls,
    User,
    UX
) {
    // @todo - Decide how to handle these. 3rd party code could re-define these just as easily as we can. -- MS

    // Global Functions //
    String.prototype.capitalize = function () {
        return this.charAt(0).toUpperCase() + this.slice(1);
    };

    String.prototype.toTitleCase = function () {
        //lowercase the whole string
        var ls = this.toLowerCase();
        //turn it into an array by splitting at spaces
        var la = ls.split(" ");
        //loop through word array
        for (var i = 0; i < la.length; i++ ) {
            //replace first letter with uppercase version
            la[i] = la[i].charAt(0).toUpperCase() + la[i].slice(1);
        }
        //rejoin words and return the new string
        return la.join(" ");
    };

    /*************************************************************/
    /************** LEGACY JS CODE BELOW *************************/
    /*************************************************************/

    /****** Old Initialize.js code *********/
    /****** TODO - These should be removed */
    $(document).ready(function () {

        /*On Focus Select Text in Search Fields*/
        $("input#som_location, input#location").focus(function () {
            // only select if the text has not changed
            if (this.value === this.defaultValue) {
                this.select();
            }
        });
        // End of Search focus

        // ============================
        // Bind to tabs for ad refresh
        // ============================
        /* Attach Refresh Banner Ads to Tab */
        $(".mmf_tabs ul li a").click(function (e) {
            // Only Replace Dynamic Tabs
            if ($(this).attr("href").substring(0,1) === "#") {
                e.preventDefault();
                Ads.Refresh();
            }
        }); // End of bind to tabs for ad refresh

        // Help Icon Support
        $('.mmf_help')
            .hover(function () {
                $(this).children('.help_icon_tip').stop().show();
            }, function () {
                $(this).children('.help_icon_tip').stop().hide();
            });
    });

    function mmfToggleDiv(selector) {
        var elm = $(selector);

        if (elm.css("display") === "none") {
            elm.css("display", "");
        } else {
            elm.css("display", "none");
        }
    }

    //-------------------------------
    // Use Conversions.formatNumber()
    //-------------------------------

//    function addCommas(nStr) {
//        nStr += '';
//        var x = nStr.split('.'),
//            x1 = x[0],
//            x2 = x.length > 1 ? '.' + x[1] : '',
//            rgx = /(\d+)(\d{3})/;
//
//        while (rgx.test(x1)) {
//            x1 = x1.replace(rgx, '$1' + ',' + '$2');
//        }
//
//        return x1 + x2;
//    }

    //-------------------------------
    // Convert to using VX (aka V7)
    //-------------------------------

//    function apiParameters(jsonParams) {
//        $.extend(true, jsonParams, {
//            "consumer_key": MMF.Api.key,
//            "signed_token": MMF.Api.signed_token
//        });
//        return jsonParams;
//    }

    //-------------------------------
    // Use utils.QueryString.Get()
    //-------------------------------

//    function getUrlVars() {
//        var vars = [], hash,
//            hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
//
//        for (var i = 0; i < hashes.length; i++) {
//            hash = hashes[i].split('=');
//            vars.push(hash[0]);
//            vars[hash[0]] = hash[1];
//        }
//        return vars;
//    }
});

